/**
 * Settings - per-user secrets kept in browser cookies (never sent anywhere except as
 * request headers). Currently just the Codebeamer JWT, which workflow triggers forward as
 * Authorization: Bearer so tracker_schema inputs can be resolved via the CB Connector.
 */

import { useState } from 'react';
import { clearCbTokenCookie, getCbTokenCookie, setCbTokenCookie } from '../utils/authCookie';
import './SettingsPage.css';

export function SettingsPage() {
  const [hasCbToken, setHasCbToken] = useState(() => getCbTokenCookie() !== null);
  const [cbToken, setCbToken] = useState('');
  const [message, setMessage] = useState<string | null>(null);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    const token = cbToken.trim();
    if (!token) return;
    setCbTokenCookie(token);
    setHasCbToken(true);
    setCbToken('');
    setMessage('Codebeamer token saved.');
  };

  const handleClear = () => {
    clearCbTokenCookie();
    setHasCbToken(false);
    setMessage('Codebeamer token removed.');
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h2>Settings</h2>
      </div>

      <div className="settings-body">
        <form className="settings-card card" onSubmit={handleSave}>
          <h3>Secrets</h3>

          <div className="config-field">
            <label className="config-label" htmlFor="settings-cb-token">
              Codebeamer token (JWT)
            </label>
            <p className="config-description">
              Sent as <code>Authorization: Bearer</code> when triggering workflows - required for
              Tracker Schema inputs. Stored in a browser cookie only.
            </p>
            <p className="config-description">
              Status: <strong>{hasCbToken ? 'set' : 'not set'}</strong>
            </p>
            <input
              id="settings-cb-token"
              className="config-input"
              type="password"
              autoComplete="off"
              placeholder={hasCbToken ? 'Enter a new token to replace the saved one' : 'eyJhbGciOi...'}
              value={cbToken}
              onChange={(e) => setCbToken(e.target.value)}
            />
          </div>

          {message && <div className="settings-message">{message}</div>}

          <div className="settings-actions">
            {hasCbToken && (
              <button type="button" className="button-secondary" onClick={handleClear}>
                Remove
              </button>
            )}
            <button type="submit" className="button-primary" disabled={!cbToken.trim()}>
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
